<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_first_one"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: ["#25e4c2", "#02b6f1", "#6654e8"],
                title: {
                    text: "三产业从业人员统计",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: 40,
                    top: 15,
                    // orient: 'vertical'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid,
                xAxis: {
                    name:'年',
                    type: "category",
                    data: [],
                    ...axis,
                },
                yAxis: {
                    name: "",
                    nameLocation:'end',
                    ...axis,
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=43,44,45`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;

                option.yAxis.name = data[0].dataArr[0].units

                let x = data[0].dataArr.map((item) => item.name);
                option.legend.data = x;
                
                option.series = x.map((item) => {
                    return {
                        name: item,
                        data: [],
                        type: "bar",
                        itemStyle: {
                            barBorderRadius: 4,
                        },
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.xAxis.data.push(item.time);
                    option.xAxis.data = option.xAxis.data.slice(-5)
                    let obj = {};
                    item.dataArr.forEach((itemx) => {
                        obj[itemx.name] = itemx.value;
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                        //显示后5年的
                        item.data = item.data.slice(-5)
                    });
                });
                //处理过长的系列名称
                option.legend.data = option.legend.data.map(item=>{
                    item = item.slice(0,4)
                    console.log(item)
                    return item
                })

                option.series.forEach((item) => {
                    item.name = item.name.slice(0,4)
                });
                //
                // option.legend.data.splice(option.legend.data.length-1, 0, "")

                var myChart = echarts.init(
                    document.getElementById("echart_first_one")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_first_one {
    height:250px
}
</style>
